import React, { useState } from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { Button, Input, Select, SelectOptionType, TextArea } from "@aidkitorg/component-library";
import { HeroNumberWithFields, SummaryExpr } from "@aidkitorg/types/lib/survey";
import { generateDistroSummaryKind } from "../../../utils/adminPanel.utils";

export const AGGREGATION_OPTIONS: Array<SelectOptionType> = [
  {value: 'Count', label: 'Count'},
  {value: 'Sum', label: 'Sum'},
  {value: 'Mean', label: 'Average'},
  // TODO: add minimum, maximum, we don't have those in distro yet
]
export const getAggregationOption = (value: string) => AGGREGATION_OPTIONS.find((v) => v.value === value)


export const MetricComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode }) => {
  const [title, setTitle] = useState('')
  const [metricType, setMetricType] = useState('numeric')
  const [aggregation, setAggregation] = useState('Count')
  const [dataField, setDataField] = useState('')
  const [description, setDescription] = useState('')

  const { 
    setStagedComponents, 
    setStagedComponentsWithResults, 
    getDashboardComponentTranslation 
  } = useDashboards()

  const METRIC_TYPE_OPTIONS: Array<SelectOptionType> = [
    {value: 'numeric', label: 'Numeric'},
    {value: 'percentage', label: 'Percentage'},
    {value: 'currency', label: 'Currency'},
    {value: 'duration', label: 'Duration'}
  ]

  const getMetricTypeOption = (value: string) => METRIC_TYPE_OPTIONS.find((v) => v.value === value)

  const saveMetricComponent = async () => {
    const metricToStage: HeroNumberWithFields = {
      kind: 'Hero Number',
      title: title,
      summary: generateDistroSummaryKind(aggregation, dataField),
      useCommas: true,
    }

    switch (metricType) {
      case 'percentage':
        metricToStage.suffix = '%'
        break;
      case 'currency':
        metricToStage.prefix= '$'
        metricToStage.decimalPlaces = 2
      // TODO: handle duration
    }

    const results = await getDashboardComponentTranslation(metricToStage)

    if (results) {
      const componentWithResultsToStage = {
        ...metricToStage,
        ...results
      }

      setStagedComponents((prevState) => ([...prevState, metricToStage]))
      setStagedComponentsWithResults((prevState) => ([...prevState, componentWithResultsToStage]))
    } else {
      // TODO: handle error
    }
  }

  const isSaveDisabled = title === '' || (aggregation !== 'Count' && dataField == '')
  
  // TODO: polish to make sure all inputs are uniform visually
  return (
    <div className="flex flex-col gap-y-2">
      <div className="font-medium text-lg">
        Add Metric
      </div>
      <Input
        label="Title"
        required
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <Select
        // TODO: add required
        options={METRIC_TYPE_OPTIONS}
        label="Metric Type"
        description="Calculation done for this metric"
        labelLocation="above"
        value={getMetricTypeOption(metricType)}
        onChange={(value) => setMetricType(value.value)}
      />
      <Select
        // TODO: add required
        options={AGGREGATION_OPTIONS}
        label="Aggregation"
        description="Aggregation done for this metric"
        labelLocation="above"
        value={getAggregationOption(aggregation)}
        onChange={(value) => setAggregation(value.value)}
      />
      {aggregation !== 'Count' && (
        <Input
          label="Data Field"
          required
          value={dataField}
          onChange={(e) => setDataField(e.target.value)}
        />
      )}
      <TextArea
        label="Description"
        showLabel
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">Cancel</Button>
        <Button isDisabled={isSaveDisabled} onClick={saveMetricComponent} className="!w-1/2">Save</Button>
      </div>
    </div>
  )
}